module.exports = __webpack_public_path__ + "img/offer-banner.a7873790.png";